import { render, staticRenderFns } from "./Cotacao.vue?vue&type=template&id=14814ea7&scoped=true&"
import script from "./Cotacao.vue?vue&type=script&lang=js&"
export * from "./Cotacao.vue?vue&type=script&lang=js&"
import style0 from "./Cotacao.vue?vue&type=style&index=0&id=14814ea7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14814ea7",
  null
  
)

export default component.exports